<select
        [ngModel]="selectedItem"
        [disabled]="readonly"
        (ngModelChange)="changeValue($event)" class="logic-select">
  <option *ngFor="let choice of items" [ngValue]="choice">{{choice}}</option>
</select>
